import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Dropdown({ children, customDropdownOpen = false, customClass = '', defaultValue = null }) {
  const [dropdownOpen, toggleDropdown] = useState(false);
  const dropdownToggle = () => toggleDropdown(!dropdownOpen);
  let defaultDropdown;

  if (dropdownOpen) {
    defaultDropdown = (
      <>
        <div className="dropdown" onClick={dropdownToggle} onKeyPress={() => {}} role="button" tabIndex={0}>
          {children}
        </div>
        <button type="button" onClick={dropdownToggle} className="dropdown-overlay" />
      </>
    );
  }

  let customDropdown;

  if (customDropdownOpen) {
    customDropdown = children;
  }

  const value = (
    <>
      {defaultValue}
      <FontAwesomeIcon icon={['fal', 'caret-down']} />
    </>
  );

  return (
    <div className={`${customClass} simple-dropdown`}>
      <button type="button" className="hollow-btn" onClick={dropdownToggle}>
        {value}
      </button>
      {customDropdownOpen ? customDropdown : defaultDropdown}
    </div>
  );
}

Dropdown.propTypes = {
  customClass: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  customDropdownOpen: PropTypes.bool,
};
